import { render } from "./page-4.vue?vue&type=template&id=7881ae00&scoped=true"
import script from "./page-4.vue?vue&type=script&lang=js"
export * from "./page-4.vue?vue&type=script&lang=js"

import "./page-4.vue?vue&type=style&index=0&id=7881ae00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7881ae00"]])

export default __exports__